export const PAGE_SIZES = [
  { label: "10", value: 10 },
  { label: "15", value: 15 },
  { label: "20", value: 20 },
  { label: "25", value: 25 },
];

export const DEFAULT_PAGE_SIZE = PAGE_SIZES[0];
